import { useState } from "react";
import apiInstance from "../../../apiInstance";

const PaymentMethods = ({paymentMethods, handleDelete}) => {

    const [error, setError] = useState("");

    const handleDeletion = async (id) => {
        try {
            const res = await apiInstance.delete(`/devadmin/payment-method/${id}`);
            handleDelete && handleDelete(id);
            
        } catch (error) {
            console.error(`Error deleting payment method:`, error);
            setError(error.response.data.message || 'Something went wrong, please try again later.');
        }
    }
   
    return (
        <div className="mjsdev-dtl-section">
            <div className="mjsdev-dtl-sec-header"><h4>Payment Methods</h4></div>
            <div className="mjsdev-dtl-inner-container">
                <div className="mjsdev-error">{error}</div>
                {paymentMethods?.length > 0 ? paymentMethods.map((item) => (
                    <div className="mjsdev-dtl-row">
                        <div className="mjsdev-dtl-col">
                            <span className="mjsdev-strong">{item.paymentMethodType || '-'}</span>
                            <span>{item.card?.brand} ****{item.card?.last4}</span>
                            <span>{item.card?.country}</span>
                        </div>
                        <div className="mjsdev-dtl-col">
                            <span>Expires: {item.card?.exp_month || '-'} / {item.card?.exp_year || '-'}</span>
                            <i
                                onClick={() => handleDeletion(item._id)}
                                title="Delete"
                                className="fa-solid fa-trash"
                            ></i>
                        </div>
                    </div>
                )) : 'No records found'}
            </div>
        </div> 
    );
};

export default PaymentMethods;
